import { render, staticRenderFns } from "./WinesForm.vue?vue&type=template&id=b74434f2&scoped=true"
import script from "./WinesForm.vue?vue&type=script&lang=js"
export * from "./WinesForm.vue?vue&type=script&lang=js"
import style0 from "./WinesForm.vue?vue&type=style&index=0&id=b74434f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74434f2",
  null
  
)

export default component.exports